import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WDataLayerScriptCCD: IClientComponentDefinition = {
  name: 'WDataLayerScript',
  load: () => import(/* webpackChunkName: 'WDataLayerScript' */ '.'),
}
